export default __webpack_public_path__ + "static/media/file.b988b1d6.mp4";